import React, { Component } from 'react';

// import styles from './styles';
class AppBlank extends Component {

// componentDidMount() 
  render = () => {
      return (
        <div >
            <span>****</span>
        </div >
      );
  }
// constructor(props) { super(props); } 
// componentWillMount() {}
// componentWillReceiveProps(){} 
// shouldComponentUpdate(){} 
// componentWillUpdate(){} 
// componentDidUpdate(){} 
// componentWillUnmount(){} 

}
export default AppBlank;